import React from 'react';
import PropTypes from 'prop-types';
import { A } from '@layout/TranscriptLinks';
import { TRANSCRIPT_STATUSES } from '@config/statuses-constants';
import { stopPropagation } from '@services/stopPropagation';
import { Icon } from '@atoms';
import { FlexContainer } from '@layout';

export const TranscriptLinks = ({
  id,
  status,
  isHumanTranscriptionAvailable,
  isAITranscriptionAvailable,
}) => {
  const transcriptReadyButProcessingWithErrors = [
    'error_twilio_delete',
    'error_cloudsearch_upload',
    'error_email_send',
  ];

  if (
    !isHumanTranscriptionAvailable &&
    !isAITranscriptionAvailable &&
    status == 'complete'
  ) {
    isHumanTranscriptionAvailable = true; // backwards compatibility
  }

  const humanTranscript = isHumanTranscriptionAvailable
    ? { href: `/transcript/view/${id}` }
    : {};
  const automaticTranscript = isAITranscriptionAvailable
    ? { href: `/transcript/ai/view/${id}` }
    : {};

  return (
    status !== TRANSCRIPT_STATUSES.ERROR_UPLOADING && (
      <FlexContainer inline gap="15px">
        <A target="_blank" {...humanTranscript} onClick={stopPropagation}>
          <Icon
            name={`humanTranscript${isHumanTranscriptionAvailable ? 'Active' : ''}`}
          />
        </A>
        <A target="_blank" {...automaticTranscript} onClick={stopPropagation}>
          <Icon
            name={`automaticTranscript${isAITranscriptionAvailable ? 'Active' : ''}`}
          />
        </A>
      </FlexContainer>
    )
  );
};

TranscriptLinks.propTypes = {
  id: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  isHumanTranscriptionAvailable: PropTypes.bool,
  isAITranscriptionAvailable: PropTypes.bool,
};

TranscriptLinks.defaultProps = {
  isHumanTranscriptionAvailable: false,
  isAITranscriptionAvailable: false,
};



// WEBPACK FOOTER //
// ./components/molecules/TranscriptLinks/TranscriptLinks.js